module.exports = __webpack_public_path__ + "img/ar_banner_m.688d1d06.png";